import { render } from "./OnDemandForm.vue?vue&type=template&id=98168d12"
import script from "./OnDemandForm.vue?vue&type=script&lang=ts"
export * from "./OnDemandForm.vue?vue&type=script&lang=ts"
script.render = render

export default script